/**
 * Light or dark theme (Mike, 2026-10-06), a per-device choice kept in this browser's storage.
 * public/theme.js applies it before the page draws; this module changes it from Settings.
 */
export type ThemeChoice = "light" | "dark" | "system";

const KEY = "dueable-theme";
const deviceDark = () => window.matchMedia("(prefers-color-scheme: dark)");

export function themeChoice(): ThemeChoice {
  try {
    const saved = localStorage.getItem(KEY);
    return saved === "light" || saved === "dark" ? saved : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(choice: ThemeChoice = themeChoice()): void {
  const dark = choice === "dark" || (choice === "system" && deviceDark().matches);
  document.documentElement.dataset.theme = dark ? "dark" : "light";
}

export function setThemeChoice(choice: ThemeChoice): void {
  try {
    if (choice === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // Storage blocked: the choice still applies until the page is reloaded.
  }
  applyTheme(choice);
}

/** Follows the device's setting while the choice is "Match my device". */
export function followDeviceTheme(): void {
  deviceDark().addEventListener("change", () => {
    if (themeChoice() === "system") applyTheme("system");
  });
}
